import styled, { css } from 'styled-components';
import { colours, common } from 'themes/default';
import { Row } from 'components/shared/Layout';
import { ifProp } from 'styled-tools';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

const StyledJourneySearchDate = styled(Row)`
  .chevron-left {
    margin-right: 10px;
  }

  .chevron-right {
    margin-left: 10px;
  }
`;

const StyledDate = styled.div`
  cursor: pointer;
  align-items: center;
  padding: 0 10px 0 10px;
  border: 1px solid ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  height: 40px;
  line-height: 40px;
  border-radius: 30px;
  display: flex;

  div {
    margin-right: 10px;
  }

  svg {
    color: ${colours.Shades.BlueShade40};
    height: 42px;
    margin-left: 20px;
  }
`;

const StyledDateSearch = styled.div`
  width: 100%;

  &[data-date-offset='0'] ul > li:nth-child(3) {
    border-color: ${common.genericUiHighlightColour};
  }

  & ul {
    width: 70%;
    padding-left: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    ${ifProp(
      'isReturnJourney',
      css`
        @media (min-width: 700px) {
          width: 87%;
        }

        @media (max-width: ${MOBILE_BREAKPOINT}) {
          width: 100%;
        }
      `
    )}

    & li {
      box-sizing: border-box;
      font-size: 14px;

      @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-width: 80px;
        font-size: 12px;
      }
    }
  }

  & button {
    top: 40%;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 8px 12px;
    }

    > span:nth-child(1) {
      font-size: 14px;
      line-height: 18px;

      @media (max-width: ${MOBILE_BREAKPOINT}) {
        font-size: 12px;
        line-height: 16px;
      }
    }

    > span:nth-child(2) {
      font-size: 22px;
      font-weight: bold;
      line-height: 24px;
    }

    > div:nth-child(3) {
      > span:nth-child(1) {
        font-size: 12px;
        line-height: 12px;

        @media (max-width: ${MOBILE_BREAKPOINT}) {
          font-size: 10px;
          line-height: 10px;
        }
      }
      > div:nth-child(2) {
        > span {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }

    & div:nth-child(1) {
      font-size: 12px;

      ${ifProp(
        'isReturnJourney',
        css`
          @media (min-width: 700px) and (max-width: 850px) {
            font-size: 9px;
          }
        `
      )}
    }

    & div:nth-child(2) {
      font-size: 18px;

      ${ifProp(
        'isReturnJourney',
        css`
          @media (min-width: 700px) and (max-width: 850px) {
            font-size: 12px;
          }
        `
      )}
    }
  }
`;

export { StyledDate, StyledJourneySearchDate, StyledDateSearch };
